<template>
  <div class="align-items-center justify-content-center tutorial-popup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="tutorial-wrapper">

          <div class="popup-window">
            <div class="header"></div>
            <div class="content">
              <h2 class="title">GEEF JULLIE BEWEEGBUDDY EEN NAAM</h2>
              <div class="name-input-wrapper">
                <input v-model="buddyName" type="text" class="name-input" placeholder="Naam Buddy" :maxlength="maxLength">
                <p class="character-count">{{nameLength}} / {{maxLength}}</p>
              </div>
              <p class="error-text">{{errorText}}</p>
              <p class="body">Opgelet: na het opslaan van jullie unieke beweegbuddy, kunnen jullie geen aanpassingen
                meer doen aan de kleur, mond, oren, ogen en neus. Zorg dus zeker dat jullie tevreden zijn met hoe je
                jouw beweegbuddy hebt samengesteld.</p>


            </div>
            <div class="footer"></div>
          </div>

          <div class="button-row">

            <WhiteOutlineButton :buttonText="'Verder Bewerken'" :stretch-to-fill="false"
                                v-on:clicked="backToBuddyCreation"></WhiteOutlineButton>

            <WhiteOutlineButton :buttonText="'Buddy Opslaan'" :stretch-to-fill="false"
                                v-on:clicked="nextStepClicked"></WhiteOutlineButton>

          </div>

        </div>
      </transition>

    </div>
  </div>

</template>

<script>
  import WhiteOutlineButton from "../WhiteOutlineButton";

  export default {
    name: "NamePickPopup",
    components: {WhiteOutlineButton},
    props: {
      open: Boolean,

    },
    data() {
      return {
        show: false,
        maxLength: 15,
        nameLength: 0,
        buddyName: "",
        errorText: "",
      }
    },
    computed: {},
    mixins: [],
    methods: {


      backToBuddyCreation() {
        this.$emit("backToBuddyCreation");
      },
      nextStepClicked() {
        if (this.nameLength > 0) {
          this.$emit("nextStepClicked", this.buddyName);
        } else {
          this.errorText = "Vul een Buddy-naam in die minstens één karakter lang is";
        }
      }



    },
    mounted() {
      let that = this;
      that.show = true;

      let input = document.querySelector('.name-input');
      input.addEventListener('input', function() {
        that.nameLength = input.value.length;

        if (that.nameLength > 0) {
          that.errorText = "";
        }
      });
    },
    created() {
    },
  }


</script>

<style lang="scss" scoped>

  .tutorial-popup {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    top: 0;
    left: 0;
    display: flex;

    .popup-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .popup-window {
    width: 50%;
    height: 50%;

    .header {
      background-image: url("~@/assets/image/platform/frame/frame_medium_top.svg");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: bottom center;
      width: 50vw;
      height: calc(50vw * 0.086);
    }

    .content {
      width: 50vw;
      min-height: calc(40vh - (50vw * 0.086 * 2));
      background-image: url("~@/assets/image/platform/frame/frame_medium_mid.svg");
      background-size: 100%;
      background-position: center center;
      position: relative;
      padding: 25px;
    }

    .footer {
      background-image: url("~@/assets/image/platform/frame/frame_medium_bot.svg");
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: top center;

      width: 50vw;
      height: calc(50vw * 0.086);
    }

  }

  .title {
    color: white;
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 20px;
  }



  .body {
    color: white;
  }

  .name-input-wrapper {
    width: 100%;
    position: relative;
  }

  .name-input {
    width: 100%;
    height: 40px;
    padding: 10px;
    margin-bottom: 20px;
  }

  .character-count {
    position: absolute;
    top: 10px;
    right: 15px;
  }


  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  .button-row {
    height: 15%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .error-text {
    color: red;
  }

</style>